import cn from "@/utils/cn"
import {
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Dialog as HeadlessDialog,
} from "@headlessui/react"
import React, { ComponentPropsWithoutRef } from "react"

type DialogProps = Omit<ComponentPropsWithoutRef<"div">, "title"> & {
  title: React.ReactNode
  isOpen: boolean
  onClose: () => void
  headerRight?: React.ReactNode
}

const Dialog = (props: DialogProps) => {
  const { isOpen, className, title, onClose, children, headerRight } = props

  const doNothing = () => {} // Prevents the modal to close on backdrop click

  return (
    <HeadlessDialog
      as="div"
      open={isOpen}
      className="relative z-50 focus:outline-none"
      onClose={doNothing}
    >
      <DialogBackdrop className="fixed inset-0 bg-black/30" />
      <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel
            transition
            className={cn(
              "data-[closed]:transform-[scale(95%)] w-full max-w-4xl rounded-xl bg-white pb-6 pt-4 duration-300 ease-out data-[closed]:opacity-0",
              className
            )}
          >
            <div className="flex items-center justify-between gap-3 border-b px-6 pb-3">
              <div className="flex items-center gap-3">
                <DialogTitle as="h4" className="text-xl font-bold">
                  {title}
                </DialogTitle>
                {headerRight}
              </div>
              <span className="material-icons cursor-pointer" onClick={onClose}>
                close
              </span>
            </div>
            <div className="mt-5 px-6">{children}</div>
          </DialogPanel>
        </div>
      </div>
    </HeadlessDialog>
  )
}

export default Dialog
